import React, { useEffect } from 'react';
import { H2, P } from '../../ui/style';
import NextStepLink from '../../components/util/next-step-link/index';
import DefaultStep from '../../components/default-step/index'
import ImagePreview from '../../components/image-preview/index';
import CircularLoader from '../../components/import-steps/circular-loader';
import ImportStatus from '../../components/import-steps/import-status';
import { sprintf, __ } from '@wordpress/i18n';
import { useStateValue } from '../../store/store';
import sseImport from './sse-import'
import ajaxQueue from './ajax-queue'

const ImportSite = () => {
	const [{
		businessImagesDownloaded,
		skipImport,
		importStart,
		importEnd,
		importPercent,
		templateResponse,
		templateId,
		placeDetails,
		businessName,
		businessAddress,
		businessEmail,
		businessPhone,
		reset,
		themeStatus,
		requiredPlugins,
		currentIndex,
		completionReady
	}, dispatch] = useStateValue();

	let percentage = importPercent;

	/**
	 * Start Import.
	 */
	const startImport = async () => {
		AstraSitesAdmin.import_source = 'ai';
		percentage += 5;

		dispatch({
			type: 'set',
			importStart: true,
			importPercent: percentage,
			importStatus: __('Starting Import.', 'astra-sites'),
		})

		resetOldSite();
	}

	/**
	 * Reset Getters.
	 */
	const getResetData = () => {
		const content = new FormData();
		content.append("action", "astra-sites-set-reset-data");
		content.append("_ajax_nonce", astraSitesVars._ajax_nonce);
		return content;
	}

	const getResetCustomizer = () => {
		const customizer_content = new FormData();
		customizer_content.append("action", "astra-sites-reset-customizer-data");
		customizer_content.append("_ajax_nonce", astraSitesVars._ajax_nonce);
		return customizer_content;
	}

	const getResetSiteOptions = () => {
		const site_options = new FormData();
		site_options.append("action", "astra-sites-reset-site-options");
		site_options.append("_ajax_nonce", astraSitesVars._ajax_nonce);
		return site_options;
	}

	const getResetWidgets = () => {
		const widgets = new FormData();
		widgets.append("action", "astra-sites-reset-widgets-data");
		widgets.append("_ajax_nonce", astraSitesVars._ajax_nonce);
		return widgets;
	}

	/**
	 * 1. Reset.
	 */
	const resetOldSite = () => {

		if (!reset) {
			importCartflowsFlows();
			return;
		}
		percentage += 2;
		dispatch({
			type: 'set',
			importStatus: __('Reseting site.', 'astra-sites'),
			importPercent: percentage,
		})

		// Get reset data.
		fetch(ajaxurl, {
			method: 'post',
			body: getResetData()
		})
			.then((response) => response.json())
			.then((data) => {

				var reset_data = data.data;
				dispatch({
					type: 'set',
					resetData: data.data
				})

				/**
				 * Reset Customizer.
				 */

				dispatch({
					type: 'set',
					importStatus: __('Reseting customizer.', 'astra-sites'),
				})

				fetch(ajaxurl, {
					method: 'post',
					body: getResetCustomizer()
				})
					.then((response) => response.json())
					.then((data) => {
						percentage += 2;
						dispatch({
							type: 'set',
							importPercent: percentage,
						})

					})
					.catch((error) => {
						dispatch({
							type: 'set',
							importStatus: __('Reseting customizer Failed.', 'astra-sites'),
						})

					});


				/**
				 * Reset Site Options.
				 */
				dispatch({
					type: 'set',
					importStatus: __('Reseting site options.', 'astra-sites'),
				})

				fetch(ajaxurl, {
					method: 'post',
					body: getResetSiteOptions()
				})
					.then((response) => response.json())
					.then((data) => {
						percentage += 2;
						dispatch({
							type: 'set',
							importPercent: percentage,
						})

					})
					.catch((error) => {
						dispatch({
							type: 'set',
							importStatus: __('Reseting site options Failed.', 'astra-sites'),
						})

					});

				/**
				 * Reset Terms, Posts and Forms in Queue.
				 */

				dispatch({
					type: 'set',
					importStatus: __('Reseting terms.', 'astra-sites'),
				})

				// Reset Terms.
				reset_data['reset_terms'].forEach((term) => {
					let term_option = new FormData();
					term_option.append("action", "astra-sites-delete-terms");
					term_option.append("term_id", term);
					term_option.append("_ajax_nonce", astraSitesVars._ajax_nonce);
					ajaxQueue.add(term_option);
				});
				ajaxQueue.run();
				percentage += 2;
				dispatch({
					type: 'set',
					importPercent: percentage,
				})

				// Reset Forms.
				reset_data['reset_wp_forms'].forEach((form_id) => {
					let form_option = new FormData();
					form_option.append("action", "astra-sites-delete-wp-forms");
					form_option.append("post_id", form_id);
					form_option.append("_ajax_nonce", astraSitesVars._ajax_nonce);
					ajaxQueue.add(form_option);
				});
				ajaxQueue.run();

				percentage += 2;
				dispatch({
					type: 'set',
					importPercent: percentage,
				})

				// Reset Posts.
				reset_data['reset_posts'].forEach((form_id) => {
					let posts_option = new FormData();
					posts_option.append("action", "astra-sites-delete-posts");
					posts_option.append("post_id", form_id);
					posts_option.append("_ajax_nonce", astraSitesVars._ajax_nonce);
					ajaxQueue.add(posts_option);
				});
				ajaxQueue.run();

				percentage += 2;
				dispatch({
					type: 'set',
					importPercent: percentage,
				})

				/**
				 * Reset Widgets.
				 */
				dispatch({
					type: 'set',
					importStatus: __('Reseting widgets.', 'astra-sites'),
				})
				fetch(ajaxurl, {
					method: 'post',
					body: getResetWidgets()
				})
					.then((response) => response.json())
					.then((data) => {
						percentage += 2;
						dispatch({
							type: 'set',
							importPercent: percentage,
						})
						importCartflowsFlows();
					})
					.catch((error) => {
						dispatch({
							type: 'set',
							importStatus: __('Reseting widgets Failed.', 'astra-sites'),
						})

					});

			})
			.catch((error) => {
				importCartflowsFlows();

			});
	}

	/**
	 * 2. Import CartFlows Flows.
	 */
	const importCartflowsFlows = () => {
		const cartflows_url = encodeURI(templateResponse['astra-site-cartflows-path']) || '';

		if ('' === cartflows_url) {
			importForms();
			return;
		}

		dispatch({
			type: 'set',
			importStatus: __('Importing CartFlows flows.', 'astra-sites'),
		})

		const flows = new FormData();
		flows.append("action", "astra-sites-import-cartflows");
		flows.append("cartflows_url", cartflows_url);
		flows.append("_ajax_nonce", astraSitesVars._ajax_nonce);

		fetch(ajaxurl, {
			method: 'post',
			body: flows
		})
			.then((response) => response.json())
			.then((data) => {
				percentage += 2;
				dispatch({
					type: 'set',
					importPercent: percentage,
				})
				importForms();
			})
			.catch((error) => {
				dispatch({
					type: 'set',
					importStatus: __('Importing CartFlows flows Failed.', 'astra-sites'),
				})

			});
	}

	/**
	 * 3. Import WPForms.
	 */
	const importForms = () => {
		const wpforms_url = encodeURI(templateResponse['astra-site-wpforms-path']) || '';

		if ('' === wpforms_url) {
			importCustomizerJson();
			return;
		}

		dispatch({
			type: 'set',
			importStatus: __('Importing forms.', 'astra-sites'),
		})

		const flows = new FormData();
		flows.append("action", "astra-sites-import-wpforms");
		flows.append("wpforms_url", wpforms_url);
		flows.append("_ajax_nonce", astraSitesVars._ajax_nonce);

		fetch(ajaxurl, {
			method: 'post',
			body: flows
		})
			.then((response) => response.json())
			.then((data) => {
				percentage += 2;
				dispatch({
					type: 'set',
					importPercent: percentage,
				})
				importCustomizerJson();
			})
			.catch((error) => {
				dispatch({
					type: 'set',
					importStatus: __('Importing forms Failed.', 'astra-sites'),
				})

			});
	}

	/**
	 * 4. Import Customizer JSON.
	 */
	const importCustomizerJson = () => {
		dispatch({
			type: 'set',
			importStatus: __('Importing forms.', 'astra-sites'),
		})

		let customizer_data = JSON.stringify(templateResponse['astra-site-customizer-data']) || '';

		const forms = new FormData();
		forms.append("action", "astra-sites-import-customizer-settings");
		forms.append("customizer_data", customizer_data);
		forms.append("_ajax_nonce", astraSitesVars._ajax_nonce);

		fetch(ajaxurl, {
			method: 'post',
			body: forms
		})
			.then((response) => response.json())
			.then((data) => {
				percentage += 5;
				dispatch({
					type: 'set',
					importPercent: percentage,
				})
				importSiteContent();
			})
			.catch((error) => {
				dispatch({
					type: 'set',
					importStatus: __('Importing forms Failed.', 'astra-sites'),
				})

			});
	}

	/**
	 * 5. Import Site Comtent XML.
	 */
	const importSiteContent = () => {
		dispatch({
			type: 'set',
			importStatus: __('Importing Site Content.', 'astra-sites'),
		})

		let wxr_url = encodeURI(templateResponse['astra-site-wxr-path']) || '';

		const content = new FormData();
		content.append("action", "astra-sites-import-prepare-xml");
		content.append("wxr_url", wxr_url);
		content.append("_ajax_nonce", astraSitesVars._ajax_nonce);

		fetch(ajaxurl, {
			method: 'post',
			body: content
		})
			.then((response) => response.json())
			.then((data) => {
				percentage += 2;
				dispatch({
					type: 'set',
					importPercent: percentage,
				})
				if (false === data.success) {
					var error_msg = data.data.error || data.data;

					dispatch({
						type: 'set',
						importStatus: __('Importing Site Content Failed. - ' + astraSitesVars.xmlRequiredFilesMissing + ' - ' + error_msg, 'astra-sites'),
					})

				} else {
					// Import XML though Event Source.
					sseImport.data = data.data;
					sseImport.render(dispatch, percentage);

					var evtSource = new EventSource(sseImport.data.url);
					evtSource.onmessage = function (message) {
						var data = JSON.parse(message.data);
						switch (data.action) {
							case 'updateDelta':

								sseImport.updateDelta(data.type, data.delta);
								break;

							case 'complete':
								evtSource.close();
								importSiteOptions();
								break;
						}
					};
					evtSource.onerror = function (error) {
						evtSource.close();
						dispatch({
							type: 'set',
							importStatus: __('Importing Site Content Failed. - Import Process Interrupted', 'astra-sites'),
						})
					};
					evtSource.addEventListener('log', function (message) {
						var data = JSON.parse(message.data);
						var message = data.message || '';
						if (message && 'info' === data.level) {
							message = message.replace(/"/g, function (letter) {
								return '';
							});
						}
						dispatch({
							type: 'set',
							importStatus: __('Importing - ' + message, 'astra-sites'),
						})
					});
				}
			})
			.catch((error) => {
				dispatch({
					type: 'set',
					importStatus: __('Importing Site Content Failed.', 'astra-sites'),
				})

			});
	}

	/**
	 * 6. Import Site Option table values.
	 */
	const importSiteOptions = () => {
		dispatch({
			type: 'set',
			importStatus: __('Importing Site Options.', 'astra-sites'),
		})

		let options_data = JSON.stringify(templateResponse['astra-site-options-data']) || '';

		const site_options = new FormData();
		site_options.append("action", "astra-sites-import-options");
		site_options.append("options_data", options_data);
		site_options.append("_ajax_nonce", astraSitesVars._ajax_nonce);

		fetch(ajaxurl, {
			method: 'post',
			body: site_options
		})
			.then((response) => response.json())
			.then((data) => {
				percentage += 5;
				dispatch({
					type: 'set',
					importPercent: percentage,
				})
				importWidgets();
			})
			.catch((error) => {
				dispatch({
					type: 'set',
					importStatus: __('Importing Site Options Failed.', 'astra-sites'),
				})

			});
	}

	/**
	 * 7. Import Site Widgets.
	 */
	const importWidgets = () => {
		dispatch({
			type: 'set',
			importStatus: __('Importing Widgets.', 'astra-sites'),
		})

		let widgets_data = templateResponse['astra-site-widgets-data'] || '';

		const widgets = new FormData();
		widgets.append("action", "astra-sites-import-widgets");
		widgets.append("widgets_data", widgets_data);
		widgets.append("_ajax_nonce", astraSitesVars._ajax_nonce);

		fetch(ajaxurl, {
			method: 'post',
			body: widgets
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: 'set',
					importPercent: 90,
				})
				checkReplacementStatus();
			})
			.catch((error) => {
				dispatch({
					type: 'set',
					importStatus: __('Importing Widgets Failed.', 'astra-sites'),
				})
			});
	}

	const checkReplacementStatus = () => {

		fetch( starterTemplates.completionStatus )
		.then( response => response.json() )
		.then( ( data ) => {
			if ( 'set' === data ) {
				dispatch({
					type: 'set',
					completionReady: true,
				})
				replaceDynamicContent( false );
			} else {
				dispatch({
					type: 'set',
					importStatus: __('Waiting for personalized data to be fetched.', 'astra-sites'),
				})
				setTimeout(() => { replaceDynamicContent( true ); }, starterTemplates.retryTimeOut);
			}
		});
	}

	/**
	 * 8. Replace AI enabled data.
	 */
	const replaceDynamicContent = ( save ) => {
		dispatch({
			type: 'set',
			importStatus: __('Setting up your personalised website.', 'astra-sites'),
		})

		const replacement = new FormData();
		replacement.append("action", "astra-sites-replace-dynamic-content");
		replacement.append("place_details", JSON.stringify(placeDetails));
		replacement.append("business_name", businessName ?? '');
		replacement.append("business_address", businessAddress ?? '');
		replacement.append("business_email", businessEmail ?? '');
		replacement.append("business_phone", businessPhone ?? '');
		replacement.append("save", save);
		replacement.append("_ajax_nonce", astraSitesVars._ajax_nonce);

		fetch(ajaxurl, {
			method: 'post',
			body: replacement
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: 'set',
					importPercent: 95,
				})
				importDone();
			})
			.catch((error) => {
				dispatch({
					type: 'set',
					importStatus: __('Setting up your personalised website Failed.', 'astra-sites'),
				})

			});
	}

	/**
	 * 9. Final setup - Invoking Batch process.
	 */
	const importDone = () => {
		dispatch({
			type: 'set',
			importStatus: __('Final finishings.', 'astra-sites'),
		})

		const final_steps = new FormData();
		final_steps.append("action", "astra-sites-import-end");
		final_steps.append("_ajax_nonce", astraSitesVars._ajax_nonce);

		fetch(ajaxurl, {
			method: 'post',
			body: final_steps
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: 'set',
					importPercent: 100,
					importEnd: true,
					importStatus: __('Done. 🎉', 'astra-sites')
				})

				setTimeout( () => {
					dispatch({
						type: 'set',
						currentIndex: currentIndex + 1,
					});
				}, 2000 );

			})
			.catch((error) => {
				dispatch({
					type: 'set',
					importStatus: __('Final finishings Failed.', 'astra-sites'),
				})

			});
	}

	useEffect(() => {
		if ( themeStatus && businessImagesDownloaded && ! ( importStart || importEnd )) {
			if (null !== templateResponse) {
				startImport()
			} else {
				dispatch({
					type: 'set',
					importStatus: __('Invalid Demo ID - ' + starterTemplates.demoId, 'astra-sites'),
				})
			}

		} else {
			dispatch({
				type: 'set',
				importStatus: __('Fetching data for import.', 'astra-sites'),
			})
		}
	}, [businessImagesDownloaded, themeStatus, templateResponse]);

	return (
		<DefaultStep
			content={
				<>
					<H2>{__('We are buiding your website...', 'astra-sites')}</H2>
					<div className="ist-import-process-step-wrap">
						<CircularLoader />
						<ImportStatus />
					</div>
					<P mb2 i>{__('Sit back and relax while we build an ideal website for your business. This could take a minute or two. But you will be happy with the end result.', 'astra-sites')}</P>
				</>
			}
			actions={(skipImport || importEnd) &&
				<>
					<NextStepLink ml1>{__('Let\'s add a logo ⟶', 'astra-sites')}</NextStepLink>
				</>
			}
			preview={
				<ImagePreview fileName='step-5.png' />
			}
		/>
	)
}

export default ImportSite;
